var map = {
	"./bleu-1.png": "a04e",
	"./bleu-2.png": "65ac",
	"./bleu-3.png": "fb42",
	"./bleu-4.png": "846e",
	"./bleu-5.png": "c439",
	"./bleu-6.png": "cd71",
	"./bleu-7.png": "1d47",
	"./gris-1.png": "2799",
	"./gris-2.png": "b327",
	"./gris-3.png": "b8a9",
	"./gris-4.png": "3d33",
	"./gris-5.png": "1ac1",
	"./gris-6.png": "7963",
	"./gris-7.png": "dadc",
	"./jaune-1.png": "718a",
	"./jaune-2.png": "6237",
	"./jaune-3.png": "9ca6",
	"./jaune-4.png": "b9ab",
	"./jaune-5.png": "d73e",
	"./jaune-6.png": "2595",
	"./jaune-7.png": "a27d",
	"./marron-1.png": "daee",
	"./marron-2.png": "fbf4",
	"./marron-3.png": "af41",
	"./marron-4.png": "5e85",
	"./marron-5.png": "b945",
	"./marron-6.png": "c303",
	"./marron-7.png": "3c9b",
	"./orange-1.png": "ec0a",
	"./orange-2.png": "23ab",
	"./orange-3.png": "0399",
	"./orange-4.png": "3522",
	"./orange-5.png": "a82c",
	"./orange-6.png": "23e2",
	"./orange-7.png": "d482",
	"./rose-1.png": "99a0",
	"./rose-2.png": "360b",
	"./rose-3.png": "2204",
	"./rose-4.png": "b3b7",
	"./rose-5.png": "2bb2",
	"./rose-6.png": "d234",
	"./rose-7.png": "780e",
	"./rouge-1.png": "61ce",
	"./rouge-2.png": "c9ed",
	"./rouge-3.png": "63e2",
	"./rouge-4.png": "7318",
	"./rouge-5.png": "6ef8",
	"./rouge-6.png": "09cf",
	"./rouge-7.png": "ad6d",
	"./vert-1.png": "eeee",
	"./vert-2.png": "5b86",
	"./vert-3.png": "e30e",
	"./vert-4.png": "7854",
	"./vert-5.png": "cfe1",
	"./vert-6.png": "3af7",
	"./vert-7.png": "2759",
	"./violet-1.png": "b681",
	"./violet-2.png": "6c33",
	"./violet-3.png": "8b06",
	"./violet-4.png": "5d3d",
	"./violet-5.png": "6cd2",
	"./violet-6.png": "abb1",
	"./violet-7.png": "e962"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "f099";